import { Component, Inject, OnDestroy } from "@angular/core";
import { ActivatedRoute, Data, NavigationEnd, Router } from "@angular/router";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { isHostDev, isHostDevOrLocal, isTruthy, LOGIN_URL, popupWindow } from "app/common";
import { Compbaser } from "../../components/compbaser";
import { DialogSearchComponent } from "../../components/dialog-search/dialog-search.component";
import { MatDialog } from "@angular/material/dialog";
import { PwaPromptService } from "../../services/pwa-prompt.service";
import { TranslocoService } from "@ngneat/transloco";
import { debounceTime, filter, map, switchMap, tap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { Lib } from "../../../libs/Lib";
import { Observable } from "rxjs";
import { AccessService, AppService, AuthUserService, LocalStoreService, StoreSelectorsService } from "../../services";
import { ExperienceLevelType, experienceOptions, IAppStatic, Id, IUser } from "../../interfaces";
import { StationAddPlayerComponent } from "../../containers/stations/station-add-player/station-add-player.component";
import { SceneMimeTypes } from "../../containers/editor/scene-blocks/mime-constants";
import {AiService} from "../../services/ai/ai.service";

export declare var jQuery: any;

@Component({
    selector: "app-main",
    templateUrl: "./main.component.html",
    styleUrls: ["./main.component.scss"],
    animations: [
        trigger("fadeIn", [
            transition("* => *", [
                style({ opacity: 0 }),
                animate("300ms ease-in-out"),
            ]),
        ]),
        trigger("slidePanel", [
            state("leave", style({
                "flex": "1 1 70px",
                "max-width": "70px",
                "min-width": "70px",
            })),
            state("hide", style({
                "flex": "1 1 50px",
                "max-width": "50px",
                "min-width": "50px",
            })),
            state("enter", style({
                "flex": "1 1 285px",
                "max-width": "285px",
                "min-width": "285px",
            })),
            transition("* => leave",
                animate("200ms ease-out"),
            ),
            transition("* => hide",
                animate("200ms ease-out"),
            ),
            transition("* => enter",
                animate("100ms ease-in"),
            ),
        ]),
    ],
})

export class MainComponent extends Compbaser implements OnDestroy {
    skillOptions = experienceOptions;
    showHelpEnabled = "0";
    useAvatar;
    businessName = "";
    name = "";
    devMode = "";
    title: string;
    liveChatStatus = false;
    primaryNav = true;
    user: IUser;
    appStatic: IAppStatic;
    childComponent: any;
    enterpriseMode: boolean;
    dashboardMode: boolean;
    upgradable: boolean;
    navWidth = "285px";
    mainWidth = "100%";
    minimized = false;
    navClosed = false;
    cartTotal = 0;
    panelShownAnimation = "enter";
    uploadingPercent = 50;
    showProgress = false;
    signStudioProducts$: Observable<string>;
    navChat$: Observable<string>;
    navSearch$: Observable<string>;
    isFullFeatures: boolean;
    appSettings: IAppStatic;

    versionText = "";
    accountVer = "";
    showHelpButton = true;
    activeSceneId: Id;
    activeSceneName = "";

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    constructor(
        // private secureService: SecureService, // add to test service
        private pwaPromptService: PwaPromptService,
        private localStoreService: LocalStoreService,
        private appService: AppService,
        private storeSelector: StoreSelectorsService,
        private accessService: AccessService,
        private translocoService: TranslocoService,
        private router: Router,
        private route: ActivatedRoute,
        private authUserService: AuthUserService, @Inject(LOGIN_URL) private loginUrl: string,
        public override dialog: MatDialog,
        private aiService: AiService,
        private toastr: ToastrService) {
        super();

        // this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navChat ? value.$.navChat : '1'))
        //     .subscribe((v) => {
        //         console.log(v);
        // });
        // this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navSearch ? value.$.navSearch : '1'))
        //     .subscribe((v) => {
        //         console.log(v);
        // });
        this.setWindowUnload();
        this.signStudioProducts$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navProducts ? value.$.navProducts : "1"));
        this.navChat$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navChat ? value.$.navChat : "1"));
        this.navSearch$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navSearch ? value.$.navSearch : "1"));
        this.checkVersion().then();

        this.appService.pwaOpenInstaller();

        this.cod(
            this.storeSelector.listenSelectedScene().pipe(
                debounceTime(100), // wait 100ms after the last change
                tap((_scene) => {
                    if (!_scene?.Player) {
                        this.activeSceneId = "";
                        this.activeSceneName = "";
                    } else {
                        this.activeSceneId = _scene.Player.$.id;
                        this.activeSceneName = _scene.Player.$.label;

                        if (isTruthy(_scene.Player.$.private_child)) {
                            this.setSceneNameFromSlider();
                        }
                    }
                })
            ).subscribe(),
        );

        this.cod(
            router.events
                .pipe(
                    filter((event) => event instanceof NavigationEnd),
                    map(() => route.firstChild),
                    filter((childRoute) => childRoute !== null),
                    tap((childRoute) => {
                        this.childComponent = childRoute.component;
                    }),
                    switchMap((childRoute) => childRoute.data),
                )
                .subscribe((data: Data) => {
                    this.title = data.title;
                    this.showHelpButton = (this.router.url != "/help");
                }),
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            }),
        );
        this.cod(
            storeSelector.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                }),
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates()
                .subscribe((updates) => {
                    this.useAvatar = this.localStoreService.getStorageValConfig("useAvatar");
                    this.showHelpEnabled = this.localStoreService.getStorageValConfig("showHelpEnabled");
                    this.experienceLevel = this.localStoreService.getStorageValConfig("experienceLevel"); // Alon
                }),
        );
        this.cod(
            this.storeSelector.getLiveChatStatusV2().subscribe((i_status) => {
                this.liveChatStatus = i_status.liveStatusV2 > 0;
            }),
        );
        this.cod(
            this.storeSelector.getCartContents()
                .subscribe((i_cart) => {
                    if (!i_cart || i_cart.length === 0) return this.cartTotal = 0;
                    // this.cartTotal = i_cart.length < 10 ? '0' + i_cart.length : String(i_cart.length);
                    this.cartTotal = i_cart.length;
                }),
        );
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.businessName = i_user.businessName;
                    this.enterpriseMode = i_user.enterprise;
                    this.dashboardMode = i_user.dashboard;
                    this.upgradable = Lib.IsAccountUpgradable(i_user);
                    this.accountVer = Lib.GetAccountVersion(i_user);
                    switch (this.accountVer) {
                        case "FREE":
                            this.versionText = "Studio / Free";
                            break;
                        case "PLUS":
                            this.versionText = "Studio / Plus";
                            break;
                        case "ENTERPRISE_08":
                        case "ENTERPRISE_24":
                            this.versionText = "Studio / Enterprise";
                            break;
                        case "DASH":
                            this.versionText = "Reseller / Enterprise";
                            break;
                    }

                }),
        );
        this.cod(
            authUserService.user$
                .pipe(filter((model) => model !== null))
                .subscribe((model: IUser) => {
                    this.user = model;
                }),
        );
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                    this.name = this.appStatic.appName;
                }),
        );
        this.cod(
            this.appService.getUploadingStatus().subscribe((res) => {
                if (!res) return;
                this.uploadingPercent = res.percent;
                this.showProgress = res.show;
            }),
        );
    }

    private setSceneNameFromSlider() {
        this.cod(
            this.storeSelector.getSliderSelection().subscribe((sliderSelection) => {
                // Display slider name instead of slide name in slider editor
                if (sliderSelection.sceneId && sliderSelection.SceneTitle) {
                    this.activeSceneName = sliderSelection.SceneTitle;
                }
            }),
        );
    }

    private setWindowUnload() {
        window.onbeforeunload = (e) => {
            if (!Lib.DevMode() && this.activeSceneId) {
                this.appService.updateMultiScene([this.activeSceneId], true);
                // const message = "Did you save your changes?";
                // const f = e || window.event;
                // if (f) {
                //     f.returnValue = message;
                // }
                // return message;
            }
            return undefined;
        };

        // window.onunload = (e) => {
        //     if (this.activeSceneId) {
        //         this.appService.updateMultiScene([this.activeSceneId], true);
        //     }
        // };
    }

    async checkVersion() {
        const evt = await this.appService.checkAppVersion();
        if (evt && isHostDev()) {
            alert("found new SignStudio version " + evt);
            console.log("Found new version " + evt);
        }
    }

    onMaximized() {
        this.navWidth = "285px";
        setTimeout(() => {
            this.minimized = false;
        }, 200);
        this.panelShownAnimation = "enter";
    }

    onNavClosed() {
        this.navClosed = true;
    }

    onMinimized(event) {
        this.navWidth = "70px";
        this.panelShownAnimation = "leave";

        setTimeout(() => {
            this.minimized = true;
        }, 100);
    }

    switchNav(): void {
        this.primaryNav = !this.primaryNav;
    }

    upgrade() {
        this.appService.openWizardUpgradeDialog();
        // this.router.navigateByUrl('/home');
    }

    logout(): void {
        if (!Lib.DevMode() && this.activeSceneId) {
            this.appService.updateMultiScene([this.activeSceneId], true);
            setTimeout(() => {
                this.authUserService.logout();
                this.appService.goToHomePage(false);
            }, 3000);
        } else {
            setTimeout(() => {
                this.authUserService.logout();
                this.appService.goToHomePage(false);
            }, 1000);
        }
    }

    showAddPlayerModal() {
        StationAddPlayerComponent.createDialog(this.dialog);
        this.router.navigateByUrl("/stations");
    }

    globalSearch() {
        this.toastr.info(this.translocoService.translate("toast.searchText", {}, this.translocoService.getActiveLang()));
        this.dialog.open(DialogSearchComponent, {
            width: "600px",
        });
    }

    downloadSignPlayer() {
        const url = this.appStatic.player_sign_chrome;
        popupWindow({ url, title: "_blank", w: 600, h: 300 }, "no", "yes");
    }

    liveChat() {
        Lib.openLiveChat(true, this.user, this.appStatic);
    }

    openOnSale() {
        this.appService.openOnSaleDialog();
    }

    onExperienceLevelChange(event: any): void {
        this.localStoreService.setStorageValConfig("experienceLevel", event.value);
    }

    aiVisible() {
        return this.aiService.isDialogVisible();
    }

    toggleAi(event: MouseEvent) {
        this.aiService.x = event.clientX; // X position in pixels
        this.aiService.y = event.clientY;
        this.aiService.showDialog(!this.aiService.isDialogVisible());
    }
}

// const parser: any = new X2JS({
//     // escapeMode: true,
//     // attributePrefix: "_",
//     // arrayAccessForm: "none",
//     // emptyNodeForm: "text",
//     // enableToStringFunc: true,
//     // arrayAccessFormPaths: [],
//     // skipEmptyTextNodesForObj: true
// });
//
// const httpOptions = {
//     headers: new HttpHeaders({
//         'Content-Type': 'application/json'
//     })
// };
//
// // ,
// //     params: new HttpParams().set('BusinessId', '1234')
// // this._http.get('', httpOptions)
// const url1 = 'api/loadData.ashx?BusinessId=345834'; // for cli proxy
// const url2 = 'http://earth.signage.me:8080/loadData.ashx?businessId=345834'; // for web direct
// this._http.get(url2, httpOptions)
//     .subscribe((myData: any) => {
//         const playerData = parser.xml2js(myData.scenes['1']);
//         console.log(playerData);
//
//         // const data = JSON.parse(myData);
//         // // const myXML = this.mc.service.db.scenes[17];
//         // const parseString = require('xml2js').parseString;
//         // parseString(data, (err, result) => {
//         //     console.log(result);
//         //     // const playerComponent = this.createComponent(SceneComponent, null);
//         //     // playerComponent.usePlayerLayout = false;
//         //     // playerComponent.load(result.Player);
//         // });
//     });
